module.exports = __webpack_public_path__ + "static/media/LockMenu2.2f1dd82b.png";